export default __webpack_public_path__ + "static/media/fil-usdtlp.27fad56c.png";